import nookies from "nookies";
import HeadSeo from "../../components/HeadSeo/HeadSeo";
import Contact from "../../containers/contact";
import siteMetadata from "../../data/siteMetadata";

export const getServerSideProps = async (ctx) => {
  const cookies = nookies.get(ctx);
  const accessToken = cookies.AccessToken;
  let user = null;
  if (accessToken) {
    try {
      const res = await api_call_v2(
        ctx,
        "get",
        "getUser",
        {},
        "cloud_functions",
        true
      );
      user = res.data;
    } catch (e) { }
  }

  return {
    props: {
      user,
    },
  };
};

const RendringPage = (props) => {
  return (
    <>
      <HeadSeo
        title={`Contact - agenz ma`}
        description={`Vous souhaitez plus de renseignements ? Contactez-nous`}
        ogImageUrl={
          "https://storage.googleapis.com/headers-agenz/Logo%20300_%20300%20px.jpg"
        }
        ogTwitterImage={siteMetadata.siteLogoSquare}
        ogType={"website"}
        ogTitle={"Contact - agenz.ma"}
        ogDescription={"Vous souhaitez plus de renseignements ? Contactez-nous"}
        canonicalUrl={"https://agenz.ma/contact"}
      />
      <Contact />
    </>
  );
};
export default RendringPage;
